export default defineNuxtPlugin(async (nuxtApp) => {
  try {
    const auth = useUserStore();

    if (!auth.isLogged) {
      await auth.fetchUser();
      if (auth.user?.role_id) {
        await auth.fetchUserGames();
      }
    }
  } catch (error) {}
});
